import { createFileRoute } from "@tanstack/react-router";
import AdminSentryDebug from "@/pages/AdminSentryDebug";
import RoleGate from "@/components/auth/RoleGate";

export const Route = createFileRoute("/admin/sentry-debug/")({
  component: () => (
    <RoleGate allow={['staff']} area="Sentry Debug"><AdminSentryDebug /></RoleGate>
  ),
});
